import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onMount } from "svelte";
import { bindPropStore } from "../bindProps";
import { emit, label, list, scheduleFrame, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span> </span>`);
var root_1 = $.from_html(`<label class="slex-select-label"><!> <!></label>`);
var root_2 = $.from_html(`<span class="slex-select-check" aria-hidden="true"></span>`);
var root_3 = $.from_html(`<li role="option"><span class="slex-select-option-label"><!> <span> </span></span> <!></li>`);
var root_4 = $.from_html(`<ul class="slex-select-menu" role="listbox"></ul>`);
var root_5 = $.from_html(`<option> </option>`);
var root_6 = $.from_html(`<div class="slex-select"><!> <button type="button" class="slex-select-trigger" aria-haspopup="listbox"><span class="slex-select-value"><!> <span> </span></span> <span class="slex-select-icon" aria-hidden="true"></span></button> <!> <select class="slex-select-native" tabindex="-1" aria-hidden="true"><option> </option><!></select></div>`);

export default function Select($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let value = $.state("");
	let open = $.state(false);
	let activeIndex = $.state(-1);
	let triggerEl = $.state(null);
	const ariaLabel = $.derived(() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel));
	const baseId = $.derived(() => `slex-select-${$$props.ctx.id}`);
	const labelId = $.derived(() => `${$.get(baseId)}-label`);
	const valueId = $.derived(() => `${$.get(baseId)}-value`);
	const listboxId = $.derived(() => `${$.get(baseId)}-listbox`);

	$.user_effect(() => bindPropStore($$props.props, (next) => {
		$.set(p, next, true);
		$.set(value, next.value ?? "", true);
		$.set(activeIndex, selectedIndex(), true);
	}));

	const options = $.derived(() => list($.get(p).options).map((item) => ({
		label: text(item.label ?? item.value),
		value: text(item.value ?? item.label),
		disabled: !!item.disabled,
		icon: item.icon
	})));

	const placeholder = $.derived(() => label($$props.ctx, "select.placeholder", $.get(p).placeholder, "Select..."));
	const selected = $.derived(() => $.get(options).find((item) => item.value === text($.get(value))));
	const displayLabel = $.derived(() => $.get(selected)?.label || $.get(placeholder));

	const activeOptionId = $.derived(() => $.get(open) && $.get(activeIndex) >= 0
		? `${$.get(baseId)}-option-${$.get(activeIndex)}`
		: undefined);

	onMount(() => {
		function closeFromOutside(event) {
			const target = event.target;

			if (!target || !$.get(triggerEl)?.closest(".slex-select")?.contains(target)) close(false);
		}

		document.addEventListener("mousedown", closeFromOutside);

		return () => document.removeEventListener("mousedown", closeFromOutside);
	});

	function choose(next) {
		if ($.get(p).disabled) return;

		$.set(value, next, true);
		$.set(activeIndex, selectedIndex(), true);
		close();
		emit($$props.ctx, "change", next);
		emit($$props.ctx, "select", next);
	}

	function selectedIndex() {
		return $.get(options).findIndex((item) => item.value === text($.get(value)));
	}

	function firstEnabledIndex() {
		return $.get(options).findIndex((item) => !item.disabled);
	}

	function lastEnabledIndex() {
		for (let i = $.get(options).length - 1; i >= 0; i -= 1) {
			if (!$.get(options)[i].disabled) return i;
		}

		return -1;
	}

	function moveActive(delta) {
		if (!$.get(options).length) {
			$.set(activeIndex, -1);

			return;
		}

		const start = $.get(activeIndex) >= 0 ? $.get(activeIndex) : selectedIndex();
		let next = start;

		for (let i = 0; i < $.get(options).length; i += 1) {
			next = (next + delta + $.get(options).length) % $.get(options).length;

			if (!$.get(options)[next].disabled) {
				$.set(activeIndex, next, true);

				return;
			}
		}

		$.set(activeIndex, -1);
	}

	function openMenu(direction = 1) {
		if ($.get(p).disabled) return;

		$.set(open, true);

		const current = selectedIndex();

		$.set(
			activeIndex,
			current >= 0 && !$.get(options)[current]?.disabled
				? current
				: direction > 0 ? firstEnabledIndex() : lastEnabledIndex(),
			true
		);
	}

	function close(focusTrigger = true) {
		$.set(open, false);
		$.set(activeIndex, selectedIndex(), true);

		if (focusTrigger) scheduleFrame($$props.ctx, () => $.get(triggerEl)?.focus());
	}

	function toggle() {
		if ($.get(open)) close(false); else openMenu();
	}

	function onKeydown(event) {
		if ($.get(p).disabled) return;

		if (!$.get(open) && (event.key === "Enter" || event.key === " " || event.key === "ArrowDown" || event.key === "ArrowUp")) {
			event.preventDefault();
			openMenu(event.key === "ArrowUp" ? -1 : 1);

			return;
		}

		if (!$.get(open)) return;

		if (event.key === "ArrowDown") {
			event.preventDefault();
			moveActive(1);
		} else if (event.key === "ArrowUp") {
			event.preventDefault();
			moveActive(-1);
		} else if (event.key === "Home") {
			event.preventDefault();
			$.set(activeIndex, firstEnabledIndex(), true);
		} else if (event.key === "End") {
			event.preventDefault();
			$.set(activeIndex, lastEnabledIndex(), true);
		} else if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();

			const item = $.get(options)[$.get(activeIndex)];

			if (item && !item.disabled) choose(item.value);
		} else if (event.key === "Escape") {
			event.preventDefault();
			close();
		} else if (event.key === "Tab") {
			close(false);
		}
	}

	var div = root_6();
	var node = $.child(div);

	{
		var consequent_2 = ($$anchor) => {
			var label_1 = root_1();
			var node_1 = $.child(label_1);

			{
				var consequent = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},
						className: 'slex-select-label-icon'
					});
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).icon) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var span = root();
					var text_1 = $.child(span, true);

					$.reset(span);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).label)]);
					$.append($$anchor, span);
				};

				$.if(node_2, ($$render) => {
					if ($.get(p).label) $$render(consequent_1);
				});
			}

			$.reset(label_1);

			$.template_effect(() => {
				$.set_attribute(label_1, 'id', $.get(labelId));
				$.set_attribute(label_1, 'for', $.get(baseId));
			});

			$.append($$anchor, label_1);
		};

		$.if(node, ($$render) => {
			if ($.get(p).label || $.get(p).icon) $$render(consequent_2);
		});
	}

	var button = $.sibling(node, 2);
	var span_1 = $.child(button);
	var node_3 = $.child(span_1);

	{
		var consequent_3 = ($$anchor) => {
			InlineIcon($$anchor, {
				get name() {
					return $.get(selected).icon;
				},
				selected: true,
				className: 'slex-select-value-icon'
			});
		};

		$.if(node_3, ($$render) => {
			if ($.get(selected)?.icon) $$render(consequent_3);
		});
	}

	var span_2 = $.sibling(node_3, 2);
	var text_2 = $.child(span_2, true);

	$.reset(span_2);
	$.reset(span_1);
	$.next(2);
	$.reset(button);
	$.bind_this(button, ($$value) => $.set(triggerEl, $$value), () => $.get(triggerEl));

	var node_4 = $.sibling(button, 2);

	{
		var consequent_6 = ($$anchor) => {
			var ul = root_4();

			$.each(ul, 21, () => $.get(options), $.index, ($$anchor, item, index) => {
				const isSelected = $.derived(() => $.get(item).value === text($.get(value)));
				const isActive = $.derived(() => index === $.get(activeIndex));
				var li = root_3();
				let classes;
				var span_3 = $.child(li);
				var node_5 = $.child(span_3);

				{
					var consequent_4 = ($$anchor) => {
						InlineIcon($$anchor, {
							get name() {
								return $.get(item).icon;
							},

							get selected() {
								return $.get(isSelected);
							},
							className: 'slex-select-option-icon'
						});
					};

					$.if(node_5, ($$render) => {
						if ($.get(item).icon) $$render(consequent_4);
					});
				}

				var span_4 = $.sibling(node_5, 2);
				var text_3 = $.child(span_4, true);

				$.reset(span_4);
				$.reset(span_3);

				var node_6 = $.sibling(span_3, 2);

				{
					var consequent_5 = ($$anchor) => {
						var span_5 = root_2();

						$.append($$anchor, span_5);
					};

					$.if(node_6, ($$render) => {
						if ($.get(isSelected)) $$render(consequent_5);
					});
				}

				$.reset(li);

				$.template_effect(() => {
					$.set_attribute(li, 'id', `${$.get(baseId)}-option-${index}`);

					classes = $.set_class(li, 1, 'slex-select-option', null, classes, {
						'slex-select-option--active': $.get(isActive),
						'slex-select-option--selected': $.get(isSelected)
					});

					$.set_attribute(li, 'aria-selected', $.get(isSelected));
					$.set_attribute(li, 'aria-disabled', $.get(item).disabled || undefined);
					$.set_attribute(li, 'data-disabled', $.get(item).disabled ? "" : undefined);
					$.set_text(text_3, $.get(item).label);
				});

				$.event('mouseenter', li, () => {
					if (!$.get(item).disabled) $.set(activeIndex, index, true);
				});

				$.delegated('mousedown', li, (event) => event.preventDefault());

				$.delegated('click', li, () => {
					if (!$.get(item).disabled) choose($.get(item).value);
				});

				$.append($$anchor, li);
			});

			$.reset(ul);

			$.template_effect(() => {
				$.set_attribute(ul, 'id', $.get(listboxId));
				$.set_attribute(ul, 'aria-labelledby', $.get(p).label ? $.get(labelId) : undefined);
				$.set_attribute(ul, 'aria-label', !$.get(p).label && $.get(ariaLabel) ? $.get(ariaLabel) : undefined);
			});

			$.append($$anchor, ul);
		};

		$.if(node_4, ($$render) => {
			if ($.get(open)) $$render(consequent_6);
		});
	}

	var select = $.sibling(node_4, 2);
	var option = $.child(select);
	var text_4 = $.child(option, true);

	$.reset(option);
	option.value = option.__value = '';

	var node_7 = $.sibling(option);

	$.each(node_7, 17, () => $.get(options), $.index, ($$anchor, item) => {
		var option_1 = root_5();
		var text_5 = $.child(option_1, true);

		$.reset(option_1);

		var option_1_value = {};

		$.template_effect(() => {
			option_1.disabled = $.get(item).disabled;
			$.set_text(text_5, $.get(item).label);

			if (option_1_value !== (option_1_value = $.get(item).value)) {
				option_1.value = (option_1.__value = $.get(item).value) ?? '';
			}
		});

		$.append($$anchor, option_1);
	});

	$.reset(select);
	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_attribute(div, 'data-variant', $0);
			$.set_attribute(button, 'id', $.get(baseId));
			button.disabled = !!$.get(p).disabled;
			$.set_attribute(button, 'aria-expanded', $.get(open));
			$.set_attribute(button, 'aria-controls', $.get(listboxId));
			$.set_attribute(button, 'aria-activedescendant', $.get(activeOptionId));
			$.set_attribute(button, 'aria-labelledby', $.get(p).label ? `${$.get(labelId)} ${$.get(valueId)}` : undefined);
			$.set_attribute(button, 'aria-label', !$.get(p).label && $.get(ariaLabel) ? $.get(ariaLabel) : undefined);
			$.set_attribute(span_1, 'id', $.get(valueId));
			$.set_attribute(span_1, 'data-placeholder', $.get(selected) ? undefined : "");
			$.set_text(text_2, $.get(displayLabel));
			select.disabled = !!$.get(p).disabled;
			select.required = !!$.get(p).required;
			$.set_attribute(select, 'aria-label', $.get(ariaLabel) || undefined);
			option.disabled = !!$.get(p).required;
			$.set_text(text_4, $1);
		},
		[
			() => text($.get(p).variant, "default"),
			() => label($$props.ctx, "select.placeholder", $.get(p).placeholder, "Select...")
		]
	);

	$.delegated('click', button, toggle);
	$.delegated('keydown', button, onKeydown);
	$.delegated('change', select, (event) => choose(event.target.value));
	$.bind_select_value(select, () => $.get(value), ($$value) => $.set(value, $$value));
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click', 'keydown', 'mousedown', 'change']);